// extracted by mini-css-extract-plugin
export default {"instruction_wrapper":"screenInstructions_instruction_wrapper__x-Bg8","instruction":"screenInstructions_instruction__EJOdf"};